export default __webpack_public_path__ + "static/media/artistBanner.926b17d0.png";